import { UserService } from './user/user.service';
import { ProfileService } from './profile.service';
import { StatCalculatorService } from './stat-calculator.service';
import { EntryService } from './entry/entry.service';
import { StatService } from './stat/stat.service';
import { StaticService } from './static/static.service';
import { TimebankService } from './timebank/timebank.service';
import { PayPeriodService } from './payperiod/payperiod.service';
import { NotificationsService } from './notifications/notifications.service';
import { TimesheetService } from './timesheet/timesheet.service';
import { ActingService } from './acting/acting.service';
import { DelegationsService } from './delegation/delegations.service';

export const services: any[] = [
  UserService,
  ProfileService,
  StatCalculatorService,
  EntryService,
  StatService,
  StaticService,
  TimebankService,
  PayPeriodService,
  NotificationsService,
  TimesheetService,
  ActingService,
  DelegationsService
];

export * from './user/user.service';
export * from './profile.service';
export * from './stat-calculator.service';
export * from './entry/entry.service';
export * from './stat/stat.service';
export * from './static/static.service';
export * from './timebank/timebank.service';
export * from './payperiod/payperiod.service';
export * from './notifications/notifications.service';
export * from './timesheet/timesheet.service';
export * from './acting/acting.service';
export * from './delegation/delegations.service';
